import React, { useState, useEffect } from "react";
import { Drawer, Button, Input, Form, Select, message } from "antd"; // Changed Modal to Drawer
import "./GenericModal.css";

const { Option } = Select;

const GenericModal = ({
  isVisible,
  handleOk,
  handleCancel,
  title,
  inputs, // Array of input fields with attributes (label, name, type, require)
  actions, // Array of buttons like ['Submit', 'Cancel']
  actionFunctions, // Array of functions corresponding to the actions
  predefinedData = {}, // Optional predefined data for edit forms
}) => {
  const [form] = Form.useForm(); // Ant Design form instance
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (isVisible) {
      if (predefinedData && Object.keys(predefinedData).length > 0) {
        console.log("Predefined Data in Modal:", predefinedData); // Debugging: Check predefinedData
        setFormData(predefinedData);
        form.setFieldsValue(predefinedData); // Set predefined values to the form
      } else {
        setFormData({});
        form.resetFields(); // Reset form if no predefined data
      }
    }
  }, [isVisible]);

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle select changes
  const handleSelectChange = (value, fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: value,
    });
  };

  // Generate form items dynamically based on input props
  const formItems = inputs.map((input) => (
    <Form.Item
      key={input.name}
      label={input.label}
      name={input.name}
      rules={
        input.require
          ? [{ required: true, message: `${input.label} is required` }]
          : []
      }
    >
      {input.type === "select" ? (
        <Select
          placeholder={input.placeholder || ""}
          onChange={(value) => {
            handleSelectChange(value, input.name);
            if (input.onChange) {
              input.onChange(value); // Call the custom onChange handler
            }
          }}
        >
          {input.options &&
            input.options.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
        </Select>
      ) : (
        <Input
          type={input.type}
          name={input.name}
          onChange={(e) => {
            handleChange(e);
            if (input.onChange) {
              input.onChange(e.target.value); // Call the custom onChange handler
            }
          }}
          placeholder={input.placeholder || ""}
        />
      )}
    </Form.Item>
  ));

  // Handle form submission
  const onSubmit = () => {
    form
      .validateFields() // Validate all fields
      .then((values) => {
        actionFunctions[0](values); // Call the first action (Submit action) with form values
      })
      .catch((errorInfo) => {
        message.error("Please fill out the required fields.");
      });
  };

  return (
    <Drawer
      title={title}
      visible={isVisible} // Changed from Modal to Drawer
      onClose={handleCancel} // Changed onCancel to onClose
      footer={null} // Disable default footer
      width={480} // Optional: Adjust the drawer width
    >
      <Form form={form} layout="vertical" initialValues={predefinedData}>
        {formItems}
      </Form>
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
        {actions &&
          actionFunctions &&
          actions.length === actionFunctions.length &&
          actions.map((action, index) => (
            <Button
              style={{ marginRight: "5px" }}
              key={action}
              onClick={() =>
                index === 0 ? onSubmit() : actionFunctions[index](formData)
              }
            >
              {action}
            </Button>
          ))}
      </div>
    </Drawer>
  );
};

export default GenericModal;
